import { Injectable } from '@angular/core';
import { DataService } from '../shared-module/services/data.service';
import { environment } from '../../environments/environment';

@Injectable()
export class ProfileService {
    configuration = {
        API_ENDPOINT : environment.apiUrl,
    };

    constructor(
        private dataService: DataService ) {
    }

    public getProfile(body) {
        return this.dataService.postData(
            this.configuration.API_ENDPOINT + 'cdirpm/rest/cdirpmService/getappuserdetails', body
        );
    }
    public editProfile(body) {
        return this.dataService.postData(
            this.configuration.API_ENDPOINT + 'cdirpm/rest/cdirpmService/editappuserdetails', body
        );
    }

}
